import Vue from 'vue'
import Router from 'vue-router'
import Root from '@/components/Root'
import RedirectF7 from '@/components/RedirectF7'
import Ahmet from '@/components/Ahmet'
// import Maintenance from '@/components/Maintenance'
import GenericChartDev from '@/components/GenericChartDev'
import NomogramDev from '@/components/NomogramDev'
import Device from '@/components/Device'
import Biofeedback from '@/components/Biofeedback'
import PrintoutV1 from '@/components/PrintoutV1'
import PrintoutV2 from '@/components/PrintoutV2'
import IntegratedReport from '@/components/IntegratedReport'
import PrintVersion from '@/components/PrintVersion'
import FontDiag from '@/components/FontDiag'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/!/device', redirect: '/Device' }, // backward compatibility
    { path: '/!', redirect: '/RedirectF7' }, // backward compatibility
    { path: '/', redirect: '/RedirectF7' }, // backward compatibility
    {
      path: '/Root',
      name: 'Root',
      component: Root
    },
    {
      path: '/Ahmet',
      name: 'Ahmet',
      component: Ahmet
    },
    /* {
      path: '/Maintenance',
      name: 'Maintenance',
      component: Maintenance
    }, */
    {
      path: '/RedirectF7',
      name: 'RedirectF7',
      component: RedirectF7
    },
    {
      path: '/GenericChartDev',
      name: 'GenericChartDev',
      component: GenericChartDev
    },
    {
      path: '/NomogramDev',
      name: 'NomogramDev',
      component: NomogramDev
    },
    {
      path: '/FontDiag',
      name: 'FontDiag',
      component: FontDiag
    },
    {
      path: '/Device',
      name: 'Device',
      component: Device
    },
    {
      path: '/Biofeedback/:tip/:zaman1/:zaman2',
      name: 'Biofeedback',
      component: Biofeedback
    },
    {
      path: '/print-version/:examId',
      name: 'PrintVersion',
      component: PrintVersion
    },
    {
      path: '/print-version/:renderType/:examId',
      name: 'PrintVersion2',
      component: PrintVersion
    },
    {
      path: '/printout/:examId',
      name: 'Printout',
      component: PrintoutV2
    },
    {
      path: '/printout-v1/:examId',
      name: 'PrintoutV1',
      component: PrintoutV1
    },
    {
      path: '/integrated-report/:examId',
      name: 'IntegratedReport',
      component: IntegratedReport
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js